import { ITEM_TYPE } from "@constants";

import React from "react";

import { KcalBadge } from "@components/OrderTaking/Components/common/KcalBadge";
import { useKcalSetting } from "@components/OrderTaking/common/useKcalSetting";
import type { CalorieValue } from "@components/OrderTaking/Helpers/calories";
import { resolveKcal } from "@components/OrderTaking/Helpers/calories";

type ProductCalorieProps = {
    product: { type?: string; calorie?: CalorieValue };
    size?: "sm" | "md";
};

export function ProductCalorie({
    product,
    size,
}: ProductCalorieProps): JSX.Element | null {
    const { isCalorieActive, customIcon } = useKcalSetting();

    if (!isCalorieActive || product?.type !== ITEM_TYPE) return null;

    const kcal = resolveKcal(product);
    if (kcal <= 0) return null;

    return (
        <div className="d-flex justify-content-end align-items-center w-100">
            <KcalBadge
                kcal={kcal}
                size={size || "sm"}
                iconSrc={customIcon || undefined}
            />
        </div>
    );
}
